
import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import FormularzSrodka, { mapujSrodekDoFormularza } from '../components/FormularzSrodka';
import { apiFetch } from '../services/api';

export default function EdytujSrodek(){
  const {id}=useParams();
  const nav=useNavigate();
  const [srodek,setSrodek]=useState(null);

  useEffect(()=>{apiFetch(`/srodki-trwale/${id}`).then(setSrodek);},[id]);
  if(!srodek) return <CircularProgress/>;

  const zapisz=async payload=>{
    await apiFetch(`/srodki-trwale/${id}`,{method:'PUT',body:JSON.stringify(payload)});
    nav(`/srodki-trwale/${id}`);
  };

  return <FormularzSrodka
    tryb="edytuj"
    wartosciPoczatkowe={mapujSrodekDoFormularza(srodek)}
    parametryPoczatkowe={srodek.parametry||[]}
    amortyzacjaPoczatkowa={srodek.amortyzacja||{enabled:false}}
    onZapisz={zapisz}
    onAnuluj={()=>nav(`/srodki-trwale/${id}`)}
  />;
}
